const preRelease =
  import.meta.env.MODE === "development" ||
  import.meta.env.MODE.startsWith("staging");

export const flags = {
  handbook: preRelease,
};
